import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useController } from "@rest-hooks/react";
import OrganizationResource from "resources/organization/OrganizationResource";

import BuildingStatus from "./BuildingStatus";

import FooterLabels from "../FooterLabels";

import PublicLayout from "components/layouts/Public";

import FormSection from "ui/FormSection";

import { useError } from "utils/useErrorController";
import AuthToken from "utils/localStorage/AuthToken";
import CoursesList from "utils/localStorage/CoursesList";
import UserName from "utils/localStorage/UserName";
import SocialsForm from "./SocialsForm";

const Signup = () => {

  const searchParams = new URLSearchParams(window.location.search);
  const defaultInstagramHandle = searchParams.get('instagram');
  
  const defaultOrganization = {
    id: null,
    instagram_handle: defaultInstagramHandle,
    linktree_handle: null,
  };

  const [organization, setOrganization] = useState(defaultOrganization);
  const [step, setStep] = useState(1);

  const {fetch} = useController();
  const {loading, setLoading, handleError} = useError();
  
  const history = useHistory();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setOrganization((prevOrg) => ({
      ...prevOrg,
      [name]: value,
    }));
  };
  
  const handleInstagramSubmit = async () => {
    try {
      setLoading(true);
      const {id, linktree_url_present, courses, user_name, auth_token} = await fetch(OrganizationResource.create(), {instagram_handle: organization.instagram_handle});
      
      const newOrganization = {...organization};
      newOrganization.id = id;
      setOrganization(newOrganization);

      if (linktree_url_present) {
        setStep(3);
      } else {
        setStep(2);
      }

      AuthToken.write(auth_token);
      CoursesList.write(courses);
      UserName.write(user_name);
      setLoading(false);
    } catch (error) {
      handleError(error);
    }
  };

  const handleLinktreeSubmit = async () => {
    try {
      setLoading(true);
      const { id } = await fetch(OrganizationResource.update(), {id: organization.id}, {instagram_handle: organization.instagram_handle, linktree_handle: organization.linktree_handle});
      
      if (organization.linktree_handle && organization.linktree_handle.length > 0) {
        setStep(3);
      } else {
        history.push(`/organizations/${id}/profile`);
      }

      setLoading(false);
    } catch (error) {
      handleError(error);
    }
  };

  const fetchOrganization = async () => {
    try {     
      const { id, onboarding } = await fetch(OrganizationResource.detail(), {id: organization.id});
      
      if (onboarding === "processed") {
        history.push(`/organizations/${id}/profile`);
      }

      if (onboarding === "failed") {
        const {id} = await fetch(OrganizationResource.update(), {id: organization.id}, {instagram_handle: organization.instagram_handle});      
        history.push(`/organizations/${id}/profile`);
      }

    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    if (step === 3 && organization.id) {
      const interval = setInterval(() => {
        fetchOrganization();
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [step, organization.id]);

  return (
    <PublicLayout isLogin>
      <FormSection slim>

      {step < 3 && (
        <SocialsForm
          step={step}
          organization={organization}
          onChange={handleChange}
          onInstagramSubmit={handleInstagramSubmit}
          onLinktreeSubmit={handleLinktreeSubmit}
          loading={loading}
        />
      )}

      {step === 3 && <BuildingStatus />}
      
      </FormSection>
      <FooterLabels />
    </PublicLayout>
  );
};

export default Signup;
